module.exports = __webpack_public_path__ + "assets/anmeldung.83e6dabc.docx";